import * as ActionTypes from 'Redux/actionTypes/index';

import ajaxService from "utils/ajaxServices";
export const setLoadingStatus =  (status, dispatch) => { 
  if(dispatch) {
    dispatch({ type: ActionTypes.SET_IS_LOADING, payload: status });
  }
    
  if(status) {
    document.body.classList.add('spinnerOverlay');
  } else {
    document.body.classList.remove('spinnerOverlay');
  }
  
}

export const checkFeatures = () => async (dispatch) => {
  let featuresResult = await ajaxService.httpGet(
    "featureBaseUrl",
    "",
    "api",
    "features"
  );

  if (!featuresResult) {
    return {
      ok: false,
      isError: true,
      res: featuresResult,
    }
  }

  dispatch({
    type: ActionTypes.SET_FEATURES,
    payload: featuresResult,
  });

  return { ok: true };
}
